if (!customElements.get("f-scrolling-promotion-os")) {
  class FScrollingPromotionMobile extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (window.innerWidth >= 768) return; 

      this.promotion = this.querySelector(".f-promotion");
      this.init();
    }

    init() {
      if (this.childElementCount === 1) {
        this.promotion.classList.add("f-promotion--animated");

        for (let index = 0; index < 10; index++) {
          const clone = this.promotion.cloneNode(true);
          clone.setAttribute("aria-hidden", true);
          this.appendChild(clone);
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.classList.remove("f-scrolling-promotion--paused");
              } else {
                this.classList.add("f-scrolling-promotion--paused");
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this);
      }
    }
  }

  customElements.define("f-scrolling-promotion-os", FScrollingPromotionMobile);
}